export default "__VITE_ASSET__WW9kpFB9__"